'use strict';

var styled = require('styled-components');
var index = require('../Flex/index.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const paddingStyle = styled.css `
  padding: ${({ theme, py }) => (py ? theme.space.component.y[py] : 0)}
    ${({ theme, px }) => (px ? theme.space.component.x[px] : 0)};
`;
const cursorStyle = styled.css `
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
const colorStyle = styled.css `
  color: ${({ theme, disabled }) => (disabled ? theme.designTokens.buttonDisabledTextColor : undefined)};
  & > div > * {
    color: ${({ theme, disabled }) => (disabled ? theme.designTokens.buttonDisabledTextColor : undefined)};
  }
`;
const SummaryFlexRow = styled__default.default(index.Flex.Row) `
  ${cursorStyle}
  ${paddingStyle}
  ${colorStyle}
`;
const Accordion = styled__default.default.div `
  max-height: ${({ maxHeight }) => maxHeight};
  transition: max-height ease-in-out 0.3s, margin-bottom ease-in-out 0.3s;
  overflow: hidden;
`;
const AccordionContent = styled__default.default.div `
  ${paddingStyle}
  visibility: ${({ isOpened }) => (isOpened ? 'visible' : 'hidden')};
`;
const Styled = {
    SummaryFlexRow,
    Accordion,
    AccordionContent,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
